import './App.css';
import Footer from 'app/layout/Footer';
import MatrixBackground from 'app/layout/MatrixBackground';
import MyNavbar from 'app/layout/MyNavbar';
import ScrollToTop from 'app/layout/ScrollToTop';
import AppRoutes from 'app/routes/AppRoutes';
import { useLocation } from 'react-router-dom';

function App() {
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  return (
    <div className="app-shell">
      <ScrollToTop />
      <MatrixBackground timeout={100} />
      {!isHomePage && <MyNavbar />}
      <AppRoutes />
      {!isHomePage && <Footer />}
    </div>
  );
}

export default App;
